import { type WithBlurFocus, type WithOnChange, type WithValue } from "@common/declarations";
import withValueHOC from "@common/hocs/withValue";
import classnames from "classnames";
import * as React from "react";
import withEnterModeHOC from "./withEnterMode";

export type TextAreaProps = WithValue<string | null> &
  WithOnChange<string> &
  Partial<WithBlurFocus> & {
    id?: string;
    className?: string;
    placeholder?: string;
    rows?: number;
    cols?: number;
    minHeight?: string | number;
    style?: React.CSSProperties;
    children?: any;
    isDisabled?: boolean;
    isReadonly?: boolean;
    maxLength?: number | null;
    name?: string;
    onClick?: () => void;
    onKeyDown?: (e: React.KeyboardEvent) => void;
    qa?: string;
  };

const TextAreaBase = (props: TextAreaProps) => (
  <textarea
    className={classnames("textarea", props.className)}
    cols={props.cols}
    data-name={props.qa || props.name}
    disabled={props.isDisabled}
    id={props.id}
    maxLength={props.maxLength ?? undefined}
    name={props.name}
    onBlur={props.onBlur}
    onChange={(e) => props.onChange(e.target.value)}
    onClick={props.onClick}
    onKeyDown={props.onKeyDown}
    onFocus={props.onFocus}
    placeholder={props.placeholder}
    readOnly={props.isReadonly}
    rows={props.rows}
    style={{ ...props.style, minHeight: props.minHeight }}
    value={props.value || ""}
  />
);

const TextArea = withEnterModeHOC<TextAreaProps>(withValueHOC<string, TextAreaProps>(TextAreaBase));
export default TextArea;
